import React, { PropTypes, Component } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router'
import Helmet from 'react-helmet'
import classes from './Home.scss'

// Actions
import { orderActions, productActions, userActions } from 'redux/actionCreators'

// Components
import { Carousel, ProductItem, ProductModal } from 'components'

// Helpers
import { get, compact, isEqual } from 'lodash'
import { viewportWidth } from 'helpers/utilities'

const Decorators = [{
  component: React.createClass({
    render () {
      return <img className={classes.carouselButton} alt='icon-left' width='10' height='12' src='/images/icon-left-2.png' onClick={this.props.previousSlide} />
    }
  }),
  position: 'CenterLeft'
}, {
  component: React.createClass({
    render () {
      return <img className={classes.carouselButton} alt='icon-right' width='10' height='12' src='/images/icon-right-2.png' onClick={this.props.nextSlide} />
    }
  }),
  position: 'CenterRight'
}, {
  component: React.createClass({ render () { return <div /> } }),
  position: 'BottomCenter',
  style: { display: 'none' }
}]
@connect(state => ({
  bannerMap: get(state, ['banner', 'bannerMap']) || {},
  cartProductMap: get(state, ['order', 'cartProductMap']) || {},
  promotionalProducts: (get(state, ['product', 'promotionalProducts']) || []).slice(0, 20),
  bestSellingProducts: (get(state, ['product', 'bestSellingProducts']) || []).slice(0, 20),
  giveawayProducts: (get(state, ['product', 'giveawayProducts']) || []).slice(0, 20),
  bisProducts: (get(state, 'product.bisProducts') || []).slice(0, 20),
  userClass: get(state, ['user', 'me', 'userClass']) || 0
}), dispatch => ({
  attemptFindPromotionalProducts: (payload) =>
    dispatch(productActions.attemptFindPromotionalProducts(payload)),
  attemptFindBestSellingProducts: (payload) =>
    dispatch(productActions.attemptFindBestSellingProducts(payload)),
  attemptFindGiveawayProducts: (payload) =>
    dispatch(productActions.attemptFindGiveawayProducts(payload)),
  attemptFindBISProducts: (payload) =>
    dispatch(productActions.attemptFindBISProducts(payload)),
  attemptAddToCart: (payload) =>
    dispatch(orderActions.attemptAddToCart(payload)),
  attemptAddToWishlist: (productCode) =>
    dispatch(userActions.attemptAddToWishlist({ productCode })),
  attemptRemoveFromWishlist: (productCode) =>
    dispatch(userActions.attemptRemoveFromWishlist({ productCode })),
  setInitial: () => dispatch({ type: 'SET_INITIAL' })
}))
class Home extends Component {
  static propTypes = {
    bannerMap: PropTypes.object.isRequired,
    cartProductMap: PropTypes.object.isRequired,
    promotionalProducts: PropTypes.array.isRequired,
    bestSellingProducts: PropTypes.array.isRequired,
    giveawayProducts: PropTypes.array.isRequired,
    bisProducts: PropTypes.array.isRequired
  };

  constructor (props) {
    super(props)
    this.state = {
      slideIndex: 0,
      promotionalHeight: 0,
      bestSellingHeight: 0,
      giveawayHeight: 0,
      modalVisible: false,
      currentProduct: null,
      selectedUnitId: '0'
    }
    this._promotionalProducts = []
    this._bestSellingProducts = []
    this._giveawayProducts = []
    this._bisProducts = []
  }

  _initAmounts = (cartProductMap) => {
    const _productKeys = Object.keys(cartProductMap)
    const amounts = _productKeys.reduce((state, key) => ({
      ...state,
      [key]: get(cartProductMap, `${key}.amount`)
    }), {})
    this.setState({ amounts })
  }

  componentDidMount () {
    window.objectFitImages()
    this.props.attemptFindPromotionalProducts()
    this.props.attemptFindBestSellingProducts()
    this.props.attemptFindGiveawayProducts()
    this.props.attemptFindBISProducts()
    this._initAmounts(this.props.cartProductMap)
    setTimeout(() => {
      this.setState({
        promotionalHeight: !this._promotionalProducts ? 0 : this._promotionalProducts.reduce((maxHeight, product) =>
          maxHeight < (get(product, 'refs.productItem.clientHeight') || 0) ? product.refs.productItem.clientHeight : maxHeight
        , 0),
        bestSellingHeight: !this._bestSellingProducts ? 0 : this._bestSellingProducts.reduce((maxHeight, product) =>
          maxHeight < (get(product, 'refs.productItem.clientHeight') || 0) ? product.refs.productItem.clientHeight : maxHeight
        , 0),
        giveawayHeight: !this._giveawayProducts ? 0 : this._giveawayProducts.reduce((maxHeight, product) =>
          maxHeight < (get(product, 'refs.productItem.clientHeight') || 0) ? product.refs.productItem.clientHeight : maxHeight
        , 0),
        bisHeight: !this._bisProducts ? 0 : this._bisProducts.reduce((maxHeight, product) =>
          maxHeight < (get(product, 'refs.productItem.clientHeight') || 0) ? product.refs.productItem.clientHeight : maxHeight
        , 0)
      })
    }, 3000)
  }

  componentWillReceiveProps (nextProps) {
    if (!isEqual(this.props.cartProductMap, nextProps.cartProductMap)) {
      this._initAmounts(nextProps.cartProductMap)
    }
  }

  _renderIndicators = (activeIndex, heroes, self) => {
    return {
      component: React.createClass({
        render () {
          return (
            <div>
              {(heroes || []).map((hero, index) =>
                <div key={index} onClick={() => self.refs.carousel.goToSlide(index)} className={`${classes.indicator} ${index === activeIndex ? classes.active : ''}`} />
              )}
            </div>
          )
        }
      }),
      position: 'BottomCenter',
      style: { height: '40px', bottom: '-40px', cursor: 'pointer' }
    }
  }

  _afterSlide = (newSlideIndex) => {
    this.setState({ slideIndex: newSlideIndex })
  }

  _onModalOpen = (currentProduct) =>
    this.setState({
      modalVisible: true,
      currentProduct,
      amount: get(this.props.cartProductMap, [get(this.state, 'currentProduct.productCode'), 'amount']) || 1
    })

  _onModalClose = () =>
    this.setState({ modalVisible: false, amount: 0, selectedUnitId: '0' })

  _onModalAddToCart = () => {
    this._onModalClose()
    this.props.attemptAddToCart({
      productCode: get(this.state, ['currentProduct', 'productCode']),
      amount: parseInt(this.state[get(this.state, ['currentProduct', 'productCode'])], 10),
      price: this._price()
    })
  }

  _price = () => this.state.currentProduct[['retail', 'wholesale1', 'wholesale2', 'wholesale3', 'wholesale4'][this.props.userClass]]

  _onWishlist = (alreadyAdded) => {
    const { productCode } = this.state.currentProduct || {}
    this.setState({
      currentProduct: {
        ...this.state.currentProduct,
        userId: !alreadyAdded
      }
    })
    if (alreadyAdded) {
      this.props.attemptRemoveFromWishlist(productCode)
    } else {
      this.props.attemptAddToWishlist(productCode)
    }
  }

  _renderProduct = (product) =>
    <div key={product.productCode} className={classes.productItemWrapper}>
      <ProductItem
        product={product}
        amount={get(this.props, ['cartProductMap', product.productCode, 'amount'])}
        userClass={this.props.userClass}
        onAddToCart={this.props.attemptAddToCart}
        onAddToWishlist={this.props.attemptAddToWishlist}
        onRemoveFromWishlist={this.props.attemptRemoveFromWishlist} />
    </div>

  render () {
    const { userClass, bannerMap, promotionalProducts, bestSellingProducts, giveawayProducts, bisProducts, attemptAddToCart, attemptAddToWishlist, attemptRemoveFromWishlist, cartProductMap } = this.props
    const heroes = compact([bannerMap['home-slider1'], bannerMap['home-slider2'], bannerMap['home-slider3'], bannerMap['home-slider4']])
    const banners = compact([bannerMap['home-banner1'], bannerMap['home-banner2'], bannerMap['home-banner3'], bannerMap['home-banner4']])
    const carouselProps = {
      decorators: Decorators,
      slidesToShow: viewportWidth() > 767 ? 7 : 3,
      slidesToScroll: viewportWidth() > 767 ? 7 : 3,
      framePadding: '20px',
      style: viewportWidth() > 767 ? {} : { width: 'calc(100vw - 20px)', margin: '0px 10px', height: 300 }
    }

    const currentProductCode = get(this.state, 'currentProduct.productCode')

    return (
      <section className={classes.home}>
        <Helmet title='หน้าหลัก' />
        <div className={classes.heroes}>
          <Carousel ref='carousel' slideIndex={this.state.slideIndex} afterSlide={this._afterSlide}
            autoplay decorators={[this._renderIndicators(this.state.slideIndex, heroes, this)]}>
            {heroes.map(({ bannerKey, path, version, title, link }) =>
              <a key={bannerKey} href={link}><img className={classes.hero} src={`${path}?v=${version}`} alt={title} /></a>
            )}
          </Carousel>
        </div>
        <div className={classes.banners}>
          {banners.map(({ bannerKey, path, version, title, link }) =>
            <a key={bannerKey} href={link}><img className={classes.banner} src={`${path}?v=${version}`} alt={title} /></a>
          )}
        </div>
        {Boolean(giveawayProducts.length) && (
          <div className={classes.section}>
            <div className={classes.header}>
              <h2>สินค้าโปรโมชั่น (มีของแถม)</h2>
              <Link to='/home-products/promotion'>ดูสินค้าทั้งหมด</Link>
            </div>
            <div className={classes.body}>
              <Carousel {...carouselProps}>
                {giveawayProducts.map((product, index) =>
                  <ProductItem ref={(component) => { this._giveawayProducts[index] = component }} key={product.productCode}
                    product={product}
                    amount={get(cartProductMap, [`${product.productCode}-0`, 'amount'])}
                    userClass={userClass}
                    onAddToCart={attemptAddToCart}
                    onAddToWishlist={attemptAddToWishlist}
                    onRemoveFromWishlist={attemptRemoveFromWishlist}
                    onModalOpen={this._onModalOpen}
                    onModalClose={this._onModalClose} />
                )}
              </Carousel>
            </div>
          </div>
        )}
        <div className={classes.section}>
          <div className={classes.header}>
            <h2>สินค้าขายดี</h2>
            <Link to='/home-products/best-selling'>ดูสินค้าทั้งหมด</Link>
          </div>
          <div className={classes.body}>
            <Carousel {...carouselProps}>
              {bestSellingProducts.map((product, index) =>
                <ProductItem ref={(component) => { this._promotionalProducts[index] = component }} key={product.productCode}
                  product={product}
                  amount={get(cartProductMap, [`${product.productCode}-0`, 'amount'])}
                  userClass={userClass}
                  onAddToCart={attemptAddToCart}
                  onAddToWishlist={attemptAddToWishlist}
                  onRemoveFromWishlist={attemptRemoveFromWishlist}
                  onModalOpen={this._onModalOpen}
                  onModalClose={this._onModalClose} />
              )}
            </Carousel>
          </div>
        </div>
        {Boolean(bisProducts.length) && (
          <div className={classes.section}>
            <div className={classes.header}>
              <h2>Back in Stock</h2>
              <Link to='/home-products/back-in-stock'>ดูสินค้าทั้งหมด</Link>
            </div>
            <div className={classes.body}>
              <Carousel {...carouselProps}>
                {bisProducts.map((product, index) =>
                  <ProductItem ref={(component) => { this._bisProducts[index] = component }} key={product.productCode}
                    product={product}
                    amount={get(cartProductMap, [`${product.productCode}-0`, 'amount'])}
                    userClass={userClass}
                    onAddToCart={attemptAddToCart}
                    onAddToWishlist={attemptAddToWishlist}
                    onRemoveFromWishlist={attemptRemoveFromWishlist}
                    onModalOpen={this._onModalOpen}
                    onModalClose={this._onModalClose} />
                )}
              </Carousel>
            </div>
          </div>
        )}
        <div className={classes.separator} />
        <div className={classes.section}>
          <div className={classes.header}>
            <h2>สินค้าใหม่</h2>
            <Link to='/home-products/new'>ดูสินค้าทั้งหมด</Link>
          </div>
          <div className={classes.body}>
            <div className={classes.productItemsContainer}>
              {promotionalProducts.map(this._renderProduct)}
            </div>
          </div>
          {this.state.modalVisible && currentProductCode && (
            <ProductModal
              selectedUnitId={this.state.selectedUnitId || '0'}
              visible={this.state.modalVisible}
              product={this.state.currentProduct}
              userClass={userClass}
              amount={this.state.amounts[currentProductCode]}
              onUnitChange={(selectedUnitId) => this.setState({ selectedUnitId })}
              onClose={this._onModalClose}
              onAddToCart={this._onModalAddToCart}
              onWishlist={this._onWishlist} />
          )}
        </div>
      </section>
    )
  }
}

export default Home



// WEBPACK FOOTER //
// ./src/containers/User/Home/Home.js